import { Dimensions, Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Entypo from '@expo/vector-icons/Entypo';
import { useCallback } from "react";
import AntDesign from '@expo/vector-icons/AntDesign';
import { PuzzleThemeCharacter } from "../data/types";

let { width } = Dimensions.get('window');
if(width > 460){ width = 460; }
const COLUMN_WIDTH = width / 2 - 10;

export const ThemeList = ({
  albums,
  onChange
}:{
  albums: PuzzleThemeCharacter[];
  onChange: (
    item: PuzzleThemeCharacter,
    index: number
  )=> void;
}) => {

  const RenderItem = useCallback(({
    item, index
  }: {
    item: PuzzleThemeCharacter, index: number
  }) => (
    <View style={styles.card}>
      <TouchableOpacity
        style={styles.touchable}
        onPress={() => onChange(item, index)}
        // handleImagePress
      >
        <Image source={{ uri: item.role_img_url }}
          style={{ width: '100%', height: '100%' }}
          // blurRadius={ item.disabled ? 10 : 0}
          blurRadius={ 0 }
          resizeMode="cover"
        />
        {item.disabled && (
          <View style={styles.lockCoins}>
            <Entypo name="lock" size={48} style={{fontWeight: "900"}}
              color="#FFFFFF" />
            <Text style={{ color: "#FFFFFF", fontSize: 16, fontWeight: "bold", marginTop: 8 }}>
              {item.price === "sub-only" ? "sub-only" : item.price_num + " Unlock"}
            </Text>
          </View>
        )}
        <View style={styles.overlay}>
          <Text style={styles.name}>{item.role_name}</Text>
          <Text style={styles.description} numberOfLines={2}>{item.description}</Text>
          
          <View style={{ flexDirection: "row", gap: 10, marginTop: 10 }}>
            <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
              <Entypo name="images" size={18} color="#FFFFFF" />
              <Text style={{fontSize: 16, color: '#fff'}} numberOfLines={2}>x {item.imgs_number}</Text>
            </View>
            <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
              <AntDesign name="play" size={18} color="rgb(221, 110, 255)" />
              <Text style={{fontSize: 16, color: '#fff'}} numberOfLines={2}>x {item.rewarded_video_count}</Text>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  ),[albums, onChange]);
  
  return (
    <View>
      <View style={{ padding: 10 }}>
        <Text style={{
          color: "rgb(161,9,255)", fontSize: 18, fontWeight: "700",
          textAlign: "center"
        }}>
          Album
        </Text>
      </View>
      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {albums.map((item,index)=>(
          <RenderItem item={item} index={index} key={item.id} />
        ))}
      </View>
    </View>
  )
};
const styles = StyleSheet.create({
  card: {
    width: COLUMN_WIDTH,
    margin: 5,
    borderRadius: 16,
    backgroundColor: "transparent",
    overflow: 'hidden',
    aspectRatio: 9/16, // Widescreen aspect ratio (16:9)
  },
  touchable: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  lockCoins:{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    padding: 10,
  },
  name: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  description: {
    color: '#fff',
    fontSize: 12,
    opacity: 0.9,
  },
})